export class RestaurantHelper{

  restaurant: any | null = null;

  constructor(restaurant: any | null){
    this.restaurant = restaurant;
  }

  isAllergenSettingsEnabled(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("allergensMenu");
  }

  areCommentsMenuEnabled(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("commentsMenu");
  }

  isCourseRatingEnabled(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("courseRating");
  }

  isCourseCommentEnabled(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("courseComment");
  }

  areAllergensDisplayableOnCourses(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("courseAllergens");
  }

  isPaymentMenuEnabled(): boolean {
    if(!this.restaurant)return true;

    return !this.getExclusions().includes("paymentMenu");
  }

  getExclusions(): string[] {
    if(!this.restaurant)return [];

    if(this.restaurant.plan){
      return this.restaurant.plan.excl as string[];
    }else{
      return ["paymentMenu", "courseComment", "courseRating", "commentsMenu"];
    }
  }
}
